import $ from 'jquery';
import React from 'react';

const hideChartButtonLocator = '.app-shell-content ul.navbar-nav a.button-hide-graph';
const showChartButtonLocator = '.app-shell-content ul.navbar-nav a.button-show-graph';

function hideChart() {
  /* istanbul ignore next */
  if ($(hideChartButtonLocator)[0]) {
    $(hideChartButtonLocator)[0].click();

    return true;
  }

  return false;
}

function restoreChart(isChartOpen) {
  /* istanbul ignore next */
  if (isChartOpen && $(showChartButtonLocator)[0]) {
    $(showChartButtonLocator)[0].click();
  } else if (!isChartOpen && $(hideChartButtonLocator)[0]) {
    $(hideChartButtonLocator)[0].click();
  }
}

export function withToggleChart(Component) {
  return props => (
    <Component hideChart={hideChart} restoreChart={restoreChart} {...props} />
  );
}
